let BACKEND_SERVER = null;
if (process.env.REACT_APP_BACKEND_SERVER) {
  BACKEND_SERVER = process.env.REACT_APP_BACKEND_SERVER;
    // BACKEND_SERVER = "http://localhost:5001/api/v1/admin/";
} else {
  // BACKEND_SERVER = "http://localhost:5001/api/v1/admin/";
  BACKEND_SERVER = "https://api.hnrenergy.co.uk/api/v1/admin/";
}

const config = {
    // basename: only at build time to set, and don't add '/' at end off BASENAME for breadcrumbs, also don't put only '/' use blank('') instead,
    
    basename: '',
    adminDefaultPath: '/dashboard/default',
    defaultPath : '/dashboard/default',
    dispatcherDefaultPath: 'dispatch-staff/list',
    fontFamily: `'Poppins', sans-serif`,
    borderRadius: 12,
    API_SERVER: BACKEND_SERVER
};

export default config;
